import { render, staticRenderFns } from "./customer_transfer.vue?vue&type=template&id=2d5b23f8&"
import script from "./customer_transfer.vue?vue&type=script&lang=js&"
export * from "./customer_transfer.vue?vue&type=script&lang=js&"
import style0 from "./customer_transfer.vue?vue&type=style&index=0&id=2d5b23f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports